import { MdOutlinePlaylistAdd } from "react-icons/md";
export const supplierContentMenu = [
  {
    id: "1",
    name: "محصول جدید",
    path: `/dashboard/suppliers/ContentUnit/Products/addNewProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "محصولات در حال بررسی",
    path: `/dashboard/suppliers/ContentUnit/Products/myProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "3",
    name: "محصولات تایید نشده",
    path: `/dashboard/suppliers/ContentUnit/Products/submitedProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "4",
    name: "تغییر وضعیت محصول",
    path: `/dashboard/suppliers/ContentUnit/Products/changeProductStatus`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "5",
    name: "محصولات فعال",
    path: `/dashboard/suppliers/ContentUnit/Products/activeProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "6",
    name: "محصولات تمام شده",
    path: `/dashboard/suppliers/ContentUnit/Products/finishedProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "7",
    name: "محصولات راکد",
    path: `/dashboard/suppliers/ContentUnit/Products/rockedProduct`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];
